// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/arrow-up.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

#WorkControl-report {
  height: fit-content;
  justify-content: center; }
  #WorkControl-report button {
    margin-left: 50px;
    margin-top: 30px;
    background-color: #257ee0; }

.workzilla-container {
  transform: translateY(-20px);
  text-align: center;
  max-height: 200px;
  overflow: auto; }

.Workflow-start-container {
  margin-left: 50px;
  margin-top: 30px;
  height: 70vh; }
  .Workflow-start-container .Workflow-list-row {
    height: 100%; }
  .Workflow-start-container .Workflow-start-buttons {
    margin-left: 78px;
    margin-top: 10px;
    margin-bottom: 40px; }
    .Workflow-start-container .Workflow-start-buttons button {
      margin-left: 40px;
      background-color: #257ee0; }
  .Workflow-start-container .list-group {
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000; }
    .Workflow-start-container .list-group button {
      background-color: #0b1736;
      color: white; }
    .Workflow-start-container .list-group .list-group-item.active {
      background-color: #257ee0; }
  .Workflow-start-container .Workflow-start-image-container {
    min-height: 50vh;
    border: 1px solid #12234f;
    background-color: #12234f;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000; }

ol.progtrckr {
  list-style-type: none;
  padding: 0; }

ol.progtrckr li {
  display: inline-block;
  text-align: center;
  line-height: 4.23rem;
  cursor: pointer; }

ol.progtrckr li span {
  padding: 0 1.5rem;
  font-size: 1rem; }

@media (max-width: 650px) {
  .progtrckr li span {
    display: none; } }

.progtrckr em {
  display: none;
  font-weight: 700;
  padding-left: 1rem; }

@media (max-width: 650px) {
  .progtrckr em {
    display: inline; } }

ol.progtrckr li.progtrckr-todo {
  color: silver;
  border-bottom: 4px solid silver; }

ol.progtrckr li span {
  pointer-events: none; }

ol.progtrckr li.progtrckr-doing {
  color: #257ee0;
  border-bottom: 4px solid #CCCCCC; }

ol.progtrckr li.progtrckr-done {
  color: #5cb85c;
  border-bottom: 4px solid #5cb85c; }

ol.progtrckr li:after {
  content: "\\00a0\\00a0"; }

ol.progtrckr li:before {
  position: relative;
  bottom: -3.7rem;
  float: left;
  left: 50%; }

ol.progtrckr li.progtrckr-todo:before {
  content: "\\039F";
  color: silver;
  background-color: white;
  width: 1.2em;
  line-height: 1.4em; }

ol.progtrckr li.progtrckr-todo:hover:before {
  color: #ff4500; }

ol.progtrckr li.progtrckr-doing:before {
  content: "\\2022";
  color: white;
  background-color: #CCCCCC;
  width: 1.2em;
  line-height: 1.2em;
  border-radius: 1.2em; }

ol.progtrckr li.progtrckr-doing:hover:before {
  color: #ff4500; }

ol.progtrckr li.progtrckr-done:before {
  content: "\\2713";
  color: white;
  background-color: #5cb85c;
  width: 1.2em;
  line-height: 1.2em;
  border-radius: 1.2em; }

ol.progtrckr li.progtrckr-done:hover:before {
  color: #333; }

.footer-buttons {
  display: none; }

.stepzilla-container {
  margin-left: 17%;
  transform: translateY(-20px); }

.dashboard-report-container {
  position: absolute;
  top: 100px;
  right: 140px;
  z-index: 11; }

.Workflow {
  color: #fff;
  background-color: #050e25;
  height: 100vh;
  width: 100%;
  margin: 0px;
  padding: 0px;
  margin-top: 100px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px; }
  .Workflow .carousel-image-container {
    width: 70vw;
    height: 70vh;
    margin-left: 10%; }
  .Workflow .expand-container {
    position: absolute;
    top: 65px;
    left: 70px;
    height: 90vh !important;
    width: 94% !important;
    z-index: 100; }
  .Workflow .expand-container .table-container {
    max-height: 80vh !important; }
  .Workflow .expand-chart-container {
    position: absolute;
    top: 85px !important;
    left: 95px;
    height: 90vh !important;
    width: 92% !important;
    z-index: 100;
    margin-top: 0px; }
  .Workflow .dashboard-container {
    position: relative; }
  .Workflow .dashboard-main {
    height: 100px; }
    .Workflow .dashboard-main button {
      background-color: #257ee0; }
  .Workflow .dashboard-form {
    min-height: 100px; }
  .Workflow .dashboard-table {
    height: 100%; }
  .Workflow .dashboard-grid {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    margin-left: 5px;
    margin-right: 5px;
    width: 100%; }
    .Workflow .dashboard-grid .dashboard-card {
      background-color: #12234f;
      height: 39vh;
      width: 29vw;
      border: 1px solid #257ee0;
      overflow-x: hidden;
      overflow-y: hidden;
      font-size: calc(11px + 0.390625vw); }
      .Workflow .dashboard-grid .dashboard-card h5 {
        font-size: calc(14px + 0.390625vw); }
      .Workflow .dashboard-grid .dashboard-card .card-title {
        text-align: center; }
      .Workflow .dashboard-grid .dashboard-card .card-body {
        max-height: 170px; }
      .Workflow .dashboard-grid .dashboard-card .card-text {
        justify-content: space-evenly;
        display: flex; }
      .Workflow .dashboard-grid .dashboard-card .dashboard-card-span {
        margin-left: 10px; }
      .Workflow .dashboard-grid .dashboard-card .btn-toolbar {
        justify-content: space-evenly; }
  .Workflow .dashboard-options {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 120px;
    text-align: right; }
    .Workflow .dashboard-options button {
      background-color: unset;
      border-color: unset;
      border: unset;
      margin-right: 2px; }
      .Workflow .dashboard-options button svg {
        color: white;
        transform: scale(1);
        pointer-events: none; }
      .Workflow .dashboard-options button .isActive {
        color: #257ee0; }
  .Workflow .report-options-button-container {
    display: block; }
    .Workflow .report-options-button-container button:hover {
      cursor: pointer;
      color: #257ee0; }
    .Workflow .report-options-button-container svg:hover {
      cursor: pointer;
      color: #257ee0; }
  .Workflow .container {
    display: flex;
    padding: 0;
    height: 90vh;
    margin-top: 12px;
    max-width: inherit;
    flex-direction: column; }
    .Workflow .container input,
    .Workflow .container select {
      margin-bottom: 50px; }
    .Workflow .container .dashboard-main {
      width: 100%; }
    .Workflow .container .dashboard-main button {
      height: min-content;
      margin-top: 30px;
      margin-left: 20px; }
    .Workflow .container .dashboard-form-main {
      display: flex;
      flex-direction: row;
      justify-content: space-between; }
    .Workflow .container .dashboard-form {
      margin-left: 20px; }
    .Workflow .container #formdescription {
      width: 40vw; }
    .Workflow .container .ct-table-button {
      color: #fff;
      background-color: unset;
      border-color: unset;
      border: unset; }
      .Workflow .container .ct-table-button svg {
        transform: scale(1.5);
        pointer-events: none; }
    .Workflow .container .ct-table-button:hover {
      color: #0a58ca; }
    .Workflow .container .table-parent-container {
      margin-left: 0px !important;
      margin-top: 40px;
      width: 100%; }
    .Workflow .container .table-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      margin-top: 10px;
      overflow-y: auto;
      height: -webkit-fill-available;
      height: fill-available;
      color: white; }
    .Workflow .container .reportTable {
      color: white; }
    .Workflow .container .table-parent-container {
      background-color: #0b1736;
      border-radius: 2px;
      overflow-x: hidden;
      margin-left: 20px;
      overflow-y: hidden;
      height: 65vh; }
      .Workflow .container .table-parent-container table {
        color: #fff;
        font-size: 1.2vw;
        border: unset;
        overflow-y: auto; }
        .Workflow .container .table-parent-container table td,
        .Workflow .container .table-parent-container table tr,
        .Workflow .container .table-parent-container table th,
        .Workflow .container .table-parent-container table thead,
        .Workflow .container .table-parent-container table tbody {
          font-weight: unset;
          border: unset;
          font-size: 1.2vw; }
        .Workflow .container .table-parent-container table thead > tr > :nth-child(1) {
          border-bottom: 0.5px solid #222224;
          border-right: 0.5px solid #222224; }
        .Workflow .container .table-parent-container table thead > tr > th:not(:first-child) {
          border-bottom: 0.5px solid #222224;
          border-left: 0.5px solid #222224; }
        .Workflow .container .table-parent-container table tbody > tr > td:not(:first-child) {
          border-left: 0.5px solid #222224; }
        .Workflow .container .table-parent-container table tbody > tr:hover {
          background-color: #021d3e;
          cursor: pointer; }
        .Workflow .container .table-parent-container table tbody > tr > td.principal {
          border-top: 0.5px solid #222224; }
        .Workflow .container .table-parent-container table .sub > td:nth-child(1) {
          padding-left: 30px; }
        .Workflow .container .table-parent-container table .principal {
          background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
          background-repeat: no-repeat;
          background-position: right 10px top 14px; }
        .Workflow .container .table-parent-container table .principal.active {
          color: #4fc2d9;
          background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
          background-repeat: no-repeat;
          background-position: right 10px top 14px; }
    .Workflow .container .report-options {
      margin-top: 2px;
      text-align: right;
      margin-right: 10px; }
      .Workflow .container .report-options button {
        border: unset;
        margin-left: 10px;
        margin-right: 4px;
        background-color: unset; }
      .Workflow .container .report-options .btn-light:hover {
        background-color: #257ee0; }
    .Workflow .container .report-chart-options {
      margin-top: 2px;
      text-align: right;
      margin-right: 10px;
      position: absolute;
      right: 20px; }
      .Workflow .container .report-chart-options button {
        background-color: #fff;
        border: unset;
        margin-left: 10px; }
      .Workflow .container .report-chart-options .btn-light:hover {
        background-color: #257ee0; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/Workflow/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACdrD;EACE,mBAAmB;EACnB,uBAAuB,EAAA;EAFzB;IAKI,iBAAiB;IACjB,gBAAgB;IAChB,yBDGgB,EAAA;;ACCpB;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY,EAAA;EAHd;IAMI,YAAY,EAAA;EANhB;IAUI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB,EAAA;IAZvB;MAeM,iBAAiB;MACjB,yBDxBc,EAAA;ECQpB;IAqBI,yBD7C4B;IC8C5B,kBAAkB;IAClB,6BAA6B,EAAA;IAvBjC;MA0BM,yBDlD0B;MCmD1B,YAAY,EAAA;IA3BlB;MA+BM,yBDvCc,EAAA;ECQpB;IAoCI,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B,EAAA;;AAMjC;EACE,qBAAqB;EACrB,UAAU,EAAA;;AAGZ;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe,EAAA;;AAGjB;EACE,iBAAiB;EACjB,eAAe,EAAA;;AAGjB;EACE;IACE,aAAa,EAAA,EACd;;AAGH;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE;IACE,eAAe,EAAA,EAChB;;AAGH;EACE,aAAa;EACb,+BAA+B,EAAA;;AAGjC;EACE,oBAAoB,EAAA;;AAGtB;EACE,cDnGkB;ECoGlB,gCAAgC,EAAA;;AAGlC;EACE,cAAc;EACd,gCAAgC,EAAA;;AAGlC;EACE,qBAAqB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS,EAAA;;AAGX;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;EACE,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;EACE,WAAW,EAAA;;AAGb;EACE,aAAa,EAAA;;AAGf;EACE,gBAAgB;EAChB,4BAA4B,EAAA;;AAG9B;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,WDjMqB;ECkMrB,yBDrLsC;ECsLtC,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EAEjB,kBAvMoB;EAwMpB,mBAxMoB;EAyMpB,iBAxMmB,EAAA;EA6LrB;IAcI,WAAW;IACX,YAAY;IACZ,gBAAgB,EAAA;EAhBpB;IAoBI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,YAAY,EAAA;EAzBhB;IA6BI,2BAA2B,EAAA;EA7B/B;IAiCI,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,eAAe,EAAA;EAvCnB;IA2CI,kBAAkB,EAAA;EA3CtB;IA+CI,aAAa,EAAA;IA/CjB;MAkDM,yBAAyB,EAAA;EAlD/B;IAuDI,iBAAiB,EAAA;EAvDrB;IA2DI,YAAY,EAAA;EA3DhB;IA+DI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW,EAAA;IApEf;MAuEM,yBAAyB;MACzB,YAAY;MACZ,WAAW;MACX,yBAAyB;MACzB,kBAAkB;MAClB,kBAAkB;MAClB,kCAAkC,EAAA;MA7ExC;QAgFQ,kCAAkC,EAAA;MAhF1C;QAoFQ,kBAAkB,EAAA;MApF1B;QAwFQ,iBAAiB,EAAA;MAxFzB;QA4FQ,6BAA6B;QAC7B,aAAa,EAAA;MA7FrB;QAiGQ,iBAAiB,EAAA;MAjGzB;QAqGQ,6BAA6B,EAAA;EArGrC;IA2GI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB,EAAA;IA/GrB;MAkHM,uBAAuB;MACvB,mBAAmB;MACnB,aAAa;MACb,iBAAiB,EAAA;MArHvB;QAwHQ,YAAY;QACZ,mBAAmB;QACnB,oBAAoB,EAAA;MA1H5B;QA8HQ,cAAc,EAAA;EA9HtB;IAoII,cAAc,EAAA;IApIlB;MAuIM,eAAe;MACf,cAAc,EAAA;IAxIpB;MA4IM,eAAe;MACf,cAAc,EAAA;EA7IpB;IAmJI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB,EAAA;IAxJ1B;;MA4JM,mBAAmB,EAAA;IA5JzB;MAgKM,WAAW,EAAA;IAhKjB;MAoKM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB,EAAA;IAtKvB;MA0KM,aAAa;MACb,mBAAmB;MACnB,8BAA8B,EAAA;IA5KpC;MAgLM,iBAAiB,EAAA;IAhLvB;MAoLM,WAAW,EAAA;IApLjB;MAwLM,WAAW;MACX,uBAAuB;MACvB,mBAAmB;MACnB,aAAa,EAAA;MA3LnB;QA8LQ,qBAAqB;QACrB,oBAAoB,EAAA;IA/L5B;MAoMM,cAAc,EAAA;IApMpB;MAwMM,2BAA2B;MAC3B,gBAAgB;MAChB,WAAW,EAAA;IA1MjB;MA8MM,yBD3Y0B;MC4Y1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAEhB,gBAAgB;MAEhB,8BAA8B;MAC9B,sBAAsB;MACtB,YAAY,EAAA;IAzNlB;MA6NM,YAAY,EAAA;IA7NlB;MAiOM,yBD9Z0B;MC+Z1B,kBAAkB;MAClB,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB;MAClB,YAAY,EAAA;MAtOlB;QAyOQ,WDzae;QC0af,gBApaa;QAqab,aAAa;QACb,gBAAgB,EAAA;QA5OxB;;;;;UAmPU,kBAAkB;UAClB,aAAa;UACb,gBA/aW,EAAA;QA0LrB;UAyPU,kCArbqB;UAsbrB,iCAtbqB,EAAA;QA4L/B;UA8PU,kCA1bqB;UA2brB,gCA3bqB,EAAA;QA4L/B;UAmQU,gCA/bqB,EAAA;QA4L/B;UAuQU,yBDrboB;UCsbpB,eAAe,EAAA;QAxQzB;UA4QU,+BAxcqB,EAAA;QA4L/B;UAgRU,kBAAkB,EAAA;QAhR5B;UAoRU,mDAA+C;UAC/C,4BAA4B;UAC5B,wCAAwC,EAAA;QAtRlD;UA0RU,cDzdkB;UC0dlB,mDAA6C;UAC7C,4BAA4B;UAC5B,wCAAwC,EAAA;IA7RlD;MAmSM,eAAe;MACf,iBAAiB;MACjB,kBAAkB,EAAA;MArSxB;QAySQ,aAAa;QACb,iBAAiB;QACjB,iBAAiB;QACjB,uBAAuB,EAAA;MA5S/B;QAgTQ,yBAAyB,EAAA;IAhTjC;MAsTM,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,WAAW,EAAA;MA1TjB;QA6TQ,sBAAsB;QACtB,aAAa;QACb,iBAAiB,EAAA;MA/TzB;QAmUQ,yBAAyB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 30px;\n$paddingTopSize: 10px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n$positionTop: 140px;\n\n#WorkControl-report {\n  height: fit-content;\n  justify-content: center;\n\n  button {\n    margin-left: 50px;\n    margin-top: 30px;\n    background-color: $btnPrimary;\n  }\n}\n\n.workzilla-container {\n  transform: translateY(-20px);\n  text-align: center;\n  max-height: 200px;\n  overflow: auto;\n}\n\n.Workflow-start-container {\n  margin-left: 50px;\n  margin-top: 30px;\n  height: 70vh;\n\n  .Workflow-list-row {\n    height: 100%;\n  }\n\n  .Workflow-start-buttons {\n    margin-left: 78px;\n    margin-top: 10px;\n    margin-bottom: 40px;\n\n    button {\n      margin-left: 40px;\n      background-color: $btnPrimary;\n    }\n  }\n\n  .list-group {\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n\n    button {\n      background-color: $topMenuBackgroundColor;\n      color: white;\n    }\n\n    .list-group-item.active {\n      background-color: $btnPrimary;\n    }\n  }\n\n  .Workflow-start-image-container {\n    min-height: 50vh;\n    border: 1px solid #12234f;\n    background-color: #12234f;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n  }\n}\n\n\n\nol.progtrckr {\n  list-style-type: none;\n  padding: 0;\n}\n\nol.progtrckr li {\n  display: inline-block;\n  text-align: center;\n  line-height: 4.23rem;\n  cursor: pointer;\n}\n\nol.progtrckr li span {\n  padding: 0 1.5rem;\n  font-size: 1rem;\n}\n\n@media (max-width: 650px) {\n  .progtrckr li span {\n    display: none;\n  }\n}\n\n.progtrckr em {\n  display: none;\n  font-weight: 700;\n  padding-left: 1rem;\n}\n\n@media (max-width: 650px) {\n  .progtrckr em {\n    display: inline;\n  }\n}\n\nol.progtrckr li.progtrckr-todo {\n  color: silver;\n  border-bottom: 4px solid silver;\n}\n\nol.progtrckr li span {\n  pointer-events: none;\n}\n\nol.progtrckr li.progtrckr-doing {\n  color: $btnPrimary;\n  border-bottom: 4px solid #CCCCCC;\n}\n\nol.progtrckr li.progtrckr-done {\n  color: #5cb85c;\n  border-bottom: 4px solid #5cb85c;\n}\n\nol.progtrckr li:after {\n  content: \"\\00a0\\00a0\";\n}\n\nol.progtrckr li:before {\n  position: relative;\n  bottom: -3.7rem;\n  float: left;\n  left: 50%;\n}\n\nol.progtrckr li.progtrckr-todo:before {\n  content: \"\\039F\";\n  color: silver;\n  background-color: white;\n  width: 1.2em;\n  line-height: 1.4em;\n}\n\nol.progtrckr li.progtrckr-todo:hover:before {\n  color: #ff4500;\n}\n\nol.progtrckr li.progtrckr-doing:before {\n  content: \"\\2022\";\n  color: white;\n  background-color: #CCCCCC;\n  width: 1.2em;\n  line-height: 1.2em;\n  border-radius: 1.2em;\n}\n\nol.progtrckr li.progtrckr-doing:hover:before {\n  color: #ff4500;\n}\n\nol.progtrckr li.progtrckr-done:before {\n  content: \"\\2713\";\n  color: white;\n  background-color: #5cb85c;\n  width: 1.2em;\n  line-height: 1.2em;\n  border-radius: 1.2em;\n}\n\nol.progtrckr li.progtrckr-done:hover:before {\n  color: #333;\n}\n\n.footer-buttons {\n  display: none;\n}\n\n.stepzilla-container {\n  margin-left: 17%;\n  transform: translateY(-20px);\n}\n\n.dashboard-report-container {\n  position: absolute;\n  top: 100px;\n  right: 140px;\n  z-index: 11;\n}\n\n.Workflow {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: 100vh;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n  margin-top: 100px;\n\n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n  .carousel-image-container {\n    width: 70vw;\n    height: 70vh;\n    margin-left: 10%;\n  }\n\n  .expand-container {\n    position: absolute;\n    top: 65px;\n    left: 70px;\n    height: 90vh !important;\n    width: 94% !important;\n    z-index: 100;\n  }\n\n  .expand-container .table-container {\n    max-height: 80vh !important;\n  }\n\n  .expand-chart-container {\n    position: absolute;\n    top: 85px !important;\n    left: 95px;\n    height: 90vh !important;\n    width: 92% !important;\n    z-index: 100;\n    margin-top: 0px;\n  }\n\n  .dashboard-container {\n    position: relative;\n  }\n\n  .dashboard-main {\n    height: 100px;\n\n    button {\n      background-color: #257ee0;\n    }\n  }\n\n  .dashboard-form {\n    min-height: 100px;\n  }\n\n  .dashboard-table {\n    height: 100%;\n  }\n\n  .dashboard-grid {\n    height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    margin-left: 5px;\n    margin-right: 5px;\n    width: 100%;\n\n    .dashboard-card {\n      background-color: #12234f;\n      height: 39vh;\n      width: 29vw;\n      border: 1px solid #257ee0;\n      overflow-x: hidden;\n      overflow-y: hidden;\n      font-size: calc(11px + 0.390625vw);\n\n      h5 {\n        font-size: calc(14px + 0.390625vw);\n      }\n\n      .card-title {\n        text-align: center;\n      }\n\n      .card-body {\n        max-height: 170px;\n      }\n\n      .card-text {\n        justify-content: space-evenly;\n        display: flex;\n      }\n\n      .dashboard-card-span {\n        margin-left: 10px;\n      }\n\n      .btn-toolbar {\n        justify-content: space-evenly;\n      }\n    }\n  }\n\n  .dashboard-options {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    width: 120px;\n    text-align: right;\n\n    button {\n      background-color: unset;\n      border-color: unset;\n      border: unset;\n      margin-right: 2px;\n\n      svg {\n        color: white;\n        transform: scale(1);\n        pointer-events: none;\n      }\n\n      .isActive {\n        color: #257ee0;\n      }\n    }\n  }\n\n  .report-options-button-container {\n    display: block;\n\n    button:hover {\n      cursor: pointer;\n      color: #257ee0;\n    }\n\n    svg:hover {\n      cursor: pointer;\n      color: #257ee0;\n    }\n  }\n\n\n  .container {\n    display: flex;\n    padding: 0;\n    height: 90vh;\n    margin-top: 12px;\n    max-width: inherit;\n    flex-direction: column;\n\n    input,\n    select {\n      margin-bottom: 50px;\n    }\n\n    .dashboard-main {\n      width: 100%;\n    }\n\n    .dashboard-main button {\n      height: min-content;\n      margin-top: 30px;\n      margin-left: 20px;\n    }\n\n    .dashboard-form-main {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n    }\n\n    .dashboard-form {\n      margin-left: 20px;\n    }\n\n    #formdescription {\n      width: 40vw;\n    }\n\n    .ct-table-button {\n      color: #fff;\n      background-color: unset;\n      border-color: unset;\n      border: unset;\n\n      svg {\n        transform: scale(1.5);\n        pointer-events: none;\n      }\n    }\n\n    .ct-table-button:hover {\n      color: #0a58ca;\n    }\n\n    .table-parent-container {\n      margin-left: 0px !important;\n      margin-top: 40px;\n      width: 100%;\n    }\n\n    .table-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      position: relative;\n      margin-top: 10px;\n\n      overflow-y: auto;\n      height: -moz-available;\n      height: -webkit-fill-available;\n      height: fill-available;\n      color: white;\n    }\n\n    .reportTable {\n      color: white;\n    }\n\n    .table-parent-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      overflow-x: hidden;\n      margin-left: 20px;\n      overflow-y: hidden;\n      height: 65vh;\n\n      table {\n        color: $primaryFontColor;\n        font-size: $tableFontSize;\n        border: unset;\n        overflow-y: auto;\n\n        td,\n        tr,\n        th,\n        thead,\n        tbody {\n          font-weight: unset;\n          border: unset;\n          font-size: $tableFontSize;\n        }\n\n        thead>tr> :nth-child(1) {\n          border-bottom: $tableDividerLineBorderSize solid $tableDividerLineColor;\n          border-right: $tableDividerLineBorderSize solid $tableDividerLineColor;\n        }\n\n        thead>tr>th:not(:first-child) {\n          border-bottom: $tableDividerLineBorderSize solid $tableDividerLineColor;\n          border-left: $tableDividerLineBorderSize solid $tableDividerLineColor;\n        }\n\n        tbody>tr>td:not(:first-child) {\n          border-left: $tableDividerLineBorderSize solid $tableDividerLineColor;\n        }\n\n        tbody>tr:hover {\n          background-color: $inputBackgroundColor;\n          cursor: pointer;\n        }\n\n        tbody>tr>td.principal {\n          border-top: $tableDividerLineBorderSize solid $tableDividerLineColor;\n        }\n\n        .sub>td:nth-child(1) {\n          padding-left: 30px;\n        }\n\n        .principal {\n          background: url(../../../assets/arrow-down.svg);\n          background-repeat: no-repeat;\n          background-position: right 10px top 14px;\n        }\n\n        .principal.active {\n          color: $secundaryFontColor;\n          background: url(../../../assets/arrow-up.svg);\n          background-repeat: no-repeat;\n          background-position: right 10px top 14px;\n        }\n      }\n    }\n\n    .report-options {\n      margin-top: 2px;\n      text-align: right;\n      margin-right: 10px;\n\n\n      button {\n        border: unset;\n        margin-left: 10px;\n        margin-right: 4px;\n        background-color: unset;\n      }\n\n      .btn-light:hover {\n        background-color: #257ee0;\n      }\n\n    }\n\n    .report-chart-options {\n      margin-top: 2px;\n      text-align: right;\n      margin-right: 10px;\n      position: absolute;\n      right: 20px;\n\n      button {\n        background-color: #fff;\n        border: unset;\n        margin-left: 10px;\n      }\n\n      .btn-light:hover {\n        background-color: #257ee0;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
